import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ProfileRequest } from '../../requests/admin-user/profile.request';
import { ListProfileResponse } from '../../responses/admin-user/list-profile.response';
import { ProfileResponse } from '../../responses/admin-user/profile.response';
import { SupportContactModel } from 'src/app/shared/services/models/admin-user/support-contact.model';
import { SupportContactTypeModel } from 'src/app/shared/services/models/admin-user/support-contact-type.model';
import { listSupportContactResponse } from '../../responses/admin-user/list-support-contact.response';
import { ListSupportContactRequest } from '../../requests/admin-user/list-support-contact.request';


@Injectable({
  providedIn: 'root'
})
export class SupportContactService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listSupportContact(): Observable<listSupportContactResponse> {
    
    let uri = 'SupportContact'    
    return this.httpClient.get<listSupportContactResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public createSupportContact(body: ListSupportContactRequest): Observable<ReturnStruct> {
    let uri = 'SupportContact'
    return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + uri, body, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )

  }
}
